import { createFileRoute } from "@tanstack/react-router";
import DatenschutzPage from "@/pages/DatenschutzPage";
import { buildRouteHead } from "@/lib/route-head";

export const Route = createFileRoute("/datenschutz")({
  head: () =>
    buildRouteHead({
      title: "Datenschutz | Enno & Jens Agentur Wernigerode",
      description:
        "Datenschutzerklärung der Agentur Enno & Jens. Infos zu Datenverarbeitung, Kontaktanfragen, Cookies/Analytics sowie Betroffenenrechten nach DSGVO.",
      path: "/datenschutz",
    }),
  component: DatenschutzPage,
});
